import { translate } from "app/filters/i18nFilter";
import { Container, Title } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/Styled";
import styled from "styled-components";
import { Button } from "@similarweb/ui-components";
import type { FC } from "react";
import type { SegmentsModalProps } from "./types";
import { AssetsService } from "app/services/AssetsService";
import { useOnEnter } from "app/custom-hooks/useOnKeyUp";

const FooterContainer = styled.div`
    display: flex;
    gap: 4px;
    justify-content: flex-end;
`;

interface FooterProps {
    goBack: VoidFunction;
    analyzeSegment: VoidFunction;
}

export const Footer: FC<FooterProps> = (props) => {
    const { goBack, analyzeSegment } = props;
    useOnEnter(analyzeSegment);
    return (
        <FooterContainer>
            <Button
                type="flat"
                onClick={goBack}
            >
                {translate("segments.popup.checkout.footer.back")}
            </Button>
            <Button
                type="primary"
                onClick={analyzeSegment}
            >
                {translate("segments.popup.checkout.footer.analyze")}
            </Button>
        </FooterContainer>
    );
};

const BodyContainer = styled.div`
    display: flex;
    justify-content: center;
    padding-bottom: 16px;
`;

const Body = () => {
    return (
        <BodyContainer>
            <img src={AssetsService.assetUrl("/images/segments/illustration38segmentsCreation.svg")} />
        </BodyContainer>
    );
};
export const Checkout: FC<SegmentsModalProps> = (props) => {
    const { checkoutFooterProps } = props;
    return (
        <Container>
            <Title>{translate("segments.popup.checkout.title")}</Title>
            <Body />
            <Footer {...checkoutFooterProps} />
        </Container>
    );
};
